import * as React from "react";
import { useState,useEffect } from "react";
import {
  Box,
  IconButton,
  Snackbar,
  Tooltip,
  Button
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import SendIcon from "@mui/icons-material/Send";
import { DataGridPro } from "@mui/x-data-grid-pro";
import SendEmailModal from "./SendEmailModal";
import { useSelector } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import { deleteDocument } from "../../../../store/actions/documentAction";
import PermissionWrapper from "../../../Setting/PermissionWrapper";
import { hasPermission } from "../../../Setting/permissionHelper";

export default function DocumentTable({ setSelectedDoc }) {
  const rows =
    useSelector(
      (state) => state?.documentReducer.documentData?.data
    ) || [];

    console.log("rows",rows)
    const loading = useSelector(
      (state) => state.documentReducer.loading
    );
  const permissionsData = useSelector(
    (state) => state.rolePermissionReducer.userPermissionData
  );
  const canDeleteDocuments = hasPermission(
    permissionsData,
    "documents",
    "READ_WRITE"
  );

  const [selectedDocRowId, setSelectedDocRowId] = useState(null);
  const [emailModal, setEmailModal] = useState({ open: false, docs: [] });
  const [snack, setSnack] = useState({ open: false, message: "", severity: "success" });
  const [selectionModel, setSelectionModel] = useState([]);
  // const [loading, setLoading] = useState(false);
  const mappedRows = rows
  .map((item, index) => ({
    ...item,
    id: index + 1,
    type: item.docTypeAbbrevation,
    control: item.controlNo,
    ref: item.referenceNo,
    code: item.orderByCode,
    filePath: item.preSignedFileURL,
    locationNumber: item.locationNumber,
    docId: item.docId
  }))
  .filter(row => row.id !== selectedDocRowId);

  const columns = [
    { field: "type", headerName: "Doc Type", flex: 1 },
    { field: "control", headerName: "Control #", flex: 1 },
    { field: "ref", headerName: "Reference #", flex: 1 },
    // {
    //   field: "actions",
    //   headerName: "Send",
    //   width: 80,
    //   renderCell: (params) => (
    //     <Tooltip title="Send Document">
    //       <IconButton
    //         size="small"
    //         onClick={(e) => {
    //           e.stopPropagation();
    //           setEmailModal({ open: true, docs: [params.row] });
    //         }}
    //       >
    //         <SendIcon fontSize="small" />
    //       </IconButton>
    //     </Tooltip>
    //   )
    // }
    { field: "code", headerName: "code", flex: 1 },
    ...(canDeleteDocuments
      ? [
          {
            field: "delete",
            headerName: "Delete",
            width: 80,
            sortable: false,
            renderCell: (params) => (
              <Tooltip title="Delete">
                <IconButton
                  size="small"
                  color="error"
                  onClick={(e) => {
                    e.stopPropagation(); // VERY important
                    handleDelete(params.row);
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )
          }
        ]
      : [])
  ];

  const handleSendSuccess = () => {
    setSnack({
      open: true,
      message: "Email sent successfully"
    });
  };

  const downloadFile = async (url, filename) => {
    try {
      const response = await fetch(url);
  
      if (!response.ok) {
        console.error("Download failed:", url);
        return;
      }
  
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
  
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename || "document.pdf";
      document.body.appendChild(link);
      link.click();
  
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error("Download error:", err);
    }
  };
  
  const handleDownload = async () => {
    if (!selectionModel.length) return;
  
    const selectedDocs = mappedRows.filter(row =>
      selectionModel.includes(row.id)
    );
  
    for (const doc of selectedDocs) {
      await downloadFile(
        doc.filePath,
        `${doc.originalFileNameAlias || "document"}.pdf`
      );
    }
  };

  const handleDelete = async (row) => {
    try {
      const res = await deleteDocument(row.locationNumber,row.docId);
  
      if (res.httpCode!==200) {
        throw new Error("Delete failed");
      }
  
      setSnack({
        open: true,
        message: "Document deleted successfully",
        severity: "success"
      });
  
      // OPTIONAL: remove row from UI (recommended)
      setSelectedDocRowId(row.id);
  
    } catch (err) {
      setSnack({
        open: true,
        message: "Failed to delete document",
        severity: "error"
      });
    }
  };
  
  
  return (
    <Box height="100%" width="100%">
      {/* Top action */}
      <Box display="flex" justifyContent="end" gap={1} mb={1}>
        <Button
          variant="contained"
          color="primary"
          disabled={!selectionModel.length}
          onClick={handleDownload}
        >
          Download
        </Button>
        <PermissionWrapper category="documents" level="READ_WRITE">
        <Button
          startIcon={<SendIcon />}
          variant="contained"
          onClick={() =>
            setEmailModal({ open: true, docs: mappedRows })
          }
        >
          Send Docs
        </Button>
        </PermissionWrapper>
      </Box>

      <Box
        sx={{
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "rgb(11, 67, 135)",
            color: "#fff",
            fontSize: "12px"
          }
        }}
      >
        <DataGridPro
          rows={mappedRows}
          columns={columns}
          checkboxSelection
          density="compact"
          hideFooter
          loading={loading}  
          disableRowSelectionOnClick
          rowSelectionModel={selectionModel}
          onRowSelectionModelChange={(newSelection) =>
            setSelectionModel(newSelection)
          }
          onRowDoubleClick={(params) => {
            const { filePath } = params.row;
            setSelectedDoc(params.row)
            // setSelectedDoc({
            //   fileUrl: filePath,
            //   // fileType: filePath.endsWith(".pdf")
            //   //   ? "pdf"
            //   //   : "image"
            // });
          }}
        />
      </Box>

      {/* Email Modal */}
      <SendEmailModal
        open={emailModal.open}
        documents={emailModal.docs}
        onClose={() =>
          setEmailModal((prev) => ({ ...prev, open: false }))
        }
        onSuccess={handleSendSuccess}
      />

      {/* Snackbar */}
      <Snackbar
        open={snack.open}
        autoHideDuration={3000}
        message={snack.message}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center"
        }}
        // onClose={() => setSnack({ open: false, message: "" })}
        onClose={() => setSnack({ ...snack, open: false })}
      />
    </Box>
  );
}
